( function () {
	'use strict';

	function templateRevisionModalService ( uiModal, Session ) {
		function openModal ( model, successCallback, cancelCallback ) {
			uiModal.open( {
				'templateUrl'  : '/templates/templates-new/template-revision/template-revision-modal.html',
				'controller'   : 'templateRevisionModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'windowClass'  : model.customClass,
				'resolve'      : {
					'templateRevisionModalModel' : function () {
						return {
							'title'          : model.modalTitle,
							'descriptionUrl' : model.modalBodyUrl,
							'confirmTitle'   : model.confirmTitle,
							'cancelTitle'    : model.cancelTitle || 'Cancel',
							'confirm'        : model.confirm,
							'cancel'         : model.cancel,
							'identifier'     : Session.getCredentials().userId + model.identifier
						};
					}
				}
			} ).result.then( successCallback, cancelCallback );
		}

		return { 'open' : openModal };
	}

	templateRevisionModalService.$inject = [ '$modal', 'Session' ];

	angular
		.module( 'app.templates' )
		.factory( 'templateRevisionModalService', templateRevisionModalService );
} )();
